import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const Wallpaper: Site = {
  id: 'wallpaper',
  logo: 'svg/wallpaper.svg',
  label: 'Wallpaper',
  analyticsName: 'wallpaper',
  hostname: 'wallpaper.com',
  platform: 'progressive',
  selector: `${progressiveVanillaSelector}, .bodyLayer a`,
};
